const image = document.querySelector('.block-media-zoom img');
const container = document.querySelector('.block-media-zoom');
const contentContainer = document.querySelector(
	'.block-media-zoom .content-wrapper'
);
const mLeft = document.querySelector('.block-media-zoom .m_left');
const mRight = document.querySelector('.block-media-zoom .m_right');
const mBottom = document.querySelector('.block-media-zoom .m_bottom');
const imageOverlay = document.querySelector('.block-media-zoom .image-overlay');

// Get the original width of the image
const originalWidth = image.clientWidth;

function resizeImage() {
	const windowHeight = window.innerHeight;
	const containerRect = container.getBoundingClientRect();
	const imageTop = containerRect.top;

	// Calculate the percentage of container visibility in the viewport
	const visibilityPercentage = Math.min(
		Math.max(
			(windowHeight - imageTop) / (windowHeight + containerRect.height),
			0
		),
		1
	);

	//const visibilityPercentageOpposite = 1 - visibilityPercentage;
	const visibilityPercentageOppositeLess = 0.8 - visibilityPercentage;
	const visibilityPercentageOppositeLeast = 0.7 - visibilityPercentage;

	// Calculate the target width based on the visibility percentage
	// The higher the number, the faster the transition happens
	const targetWidth = visibilityPercentage * 230;

	// Ensure the image doesn't get smaller than the original width
	const minWidth =
		(originalWidth / document.documentElement.clientWidth) * 100;
	const finalWidth = Math.max(targetWidth, minWidth);

	// Apply the width to the image
	image.style.width = `${finalWidth}vw`;
	const opacityValueText = visibilityPercentage * 1.9;
	const opacityValueOverlay = visibilityPercentage * 2;
	const mAmount = visibilityPercentageOppositeLess * 20;
	const bAmount = visibilityPercentageOppositeLeast * 52;

	contentContainer.style.opacity = opacityValueText;

	imageOverlay.style.opacity = opacityValueOverlay;
	imageOverlay.style.width = `${finalWidth}vw`;

	mLeft.style.width = `${mAmount}px`;
	mRight.style.width = `${mAmount}px`;
	mBottom.style.height = `${bAmount}px`;

	// eslint-disable-next-line no-console
	//console.log('visibilityPercentage:' + visibilityPercentage);

	// eslint-disable-next-line no-console
	//console.log('visibilityPercentageOpposite:' + visibilityPercentageOpposite);
}

// Initial resize
resizeImage();

// Resize the image on scroll
window.addEventListener('scroll', resizeImage);

// Resize the image on window resize
window.addEventListener('resize', resizeImage);
